import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  isSticky: boolean = false;
  logo: string = 'assets/images/logo-white.png';
  isCollapsed = true;
  isServicesDropdownOpen = false;

  // Services array
  services = [
    { title: 'Sites Web', route: '/web' },
    { title: 'Appliaction Web', route: '/appweb' },
    { title: 'Publicité en ligne', route: '/publicite' },
    { title: 'Gestion des réseaux sociaux', route: '/gestion' },
    { title: 'Design Graphique', route: '/design' },
    { title: 'Agence SEO', route: '/agence' }
  ];

  constructor(private router: Router) {}

  toggleServicesDropdown() {
    this.isServicesDropdownOpen = !this.isServicesDropdownOpen;
  }

  closeServicesDropdown() {
    this.isServicesDropdownOpen = false;
  }

  navigateToService(route: string) {
    this.router.navigate([route]);
    this.isCollapsed = true;
    this.isServicesDropdownOpen = false;
  }

  scrollToSection(sectionId: string) {
    // Close mobile menu and dropdowns after clicking
    this.isCollapsed = true;
    this.isServicesDropdownOpen = false;

    // Handle special pages that have their own routes
    if (sectionId === 'contact') {
      this.router.navigate(['/contact']);
      return;
    }

    if (sectionId === 'about') {
      this.router.navigate(['/apropos']);
      return;
    }

    // Check if we're on the home page
    const currentUrl = this.router.url.split('#')[0]; // Remove any fragments
    const isHomePage = currentUrl === '/' || currentUrl === '/home-seven' || currentUrl === '';

    if (isHomePage) {
      // We're on home page, just scroll to section
      this.smoothScrollToSection(sectionId);
    } else {
      // We're on another page, navigate to home with fragment
      this.router.navigate(['/'], { fragment: sectionId }).then(() => {
        // Wait for navigation to complete, then scroll
        setTimeout(() => {
          this.smoothScrollToSection(sectionId);
        }, 100);
      });
    }
  }

  private smoothScrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop > 100) {  
      this.isSticky = true;
      this.logo = 'assets/images/Logo-5.png';
    } else {
      this.isSticky = false;
      this.logo = 'assets/images/Logo4.png';
    }
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.services-dropdown')) {
      this.isServicesDropdownOpen = false;
    }
  }
}